import React, { Component } from 'react';
import { AppContext } from './../AppContext';

import "tailwindcss/tailwind.css"
export class Home extends Component {
  static displayName = Home.name;

  render() {
    const currentUser = this.context;
    console.log("Home currentUser = " + JSON.stringify(currentUser));
    return (
      <div>
            <div className="text-center">

                <h1>Bienvenido al Sistema!</h1>
                <p>Para comenzar debemos ingresar al sistema de autenticacion de ESPOL</p>
                <div className="flex flex-wrap place-items-center h-screen">
                     
                    <button to="/validacion" className="p-2 pl-5 pr-5 bg-transparent border-2 border-indigo-500 text-indigo-500 text-lg rounded-lg transition-colors duration-700 transform hover:bg-indigo-500 hover:text-gray-100 focus:border-4 focus:border-indigo-300">Autenticarse</button>
                        </div>
                    </div>
       
       </div>
    );
  }
}
Home.contextType = AppContext;